import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./contexts/LanguageContext";
import HomePage from "./pages/HomePage";
import ClinicPage from "./pages/ClinicPage";
import AstonVillaPage from "./pages/AstonVillaPage";
import EnglishImmersionPage from "./pages/EnglishImmersionPage";
import TechnologyPage from "./pages/TechnologyPage";
import AboutOakhamPage from "./pages/AboutOakhamPage";
import PricesPage from "./pages/PricesPage";
import ContactPage from "./pages/ContactPage";
import SignUpPage from "./pages/SignUpPage";
import TermsPage from "./pages/TermsPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import CookiePolicyPage from "./pages/CookiePolicyPage";
import CookieConsentBanner from "./components/CookieConsentBanner";
import PromoTopbar from "./components/PromoTopbar";
import DynamicTitle from "./components/DynamicTitle";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LanguageProvider>
          <DynamicTitle />
          <PromoTopbar />
          <CookieConsentBanner />
          <Routes>
            {/* English Routes */}
            <Route path="/" element={<HomePage />} />
            <Route path="/clinic" element={<ClinicPage />} />
            <Route path="/aston-villa" element={<AstonVillaPage />} />
            <Route path="/english-immersion" element={<EnglishImmersionPage />} />
            <Route path="/technology" element={<TechnologyPage />} />
            <Route path="/about-oakham" element={<AboutOakhamPage />} />
            <Route path="/prices" element={<PricesPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/signup" element={<SignUpPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/cookie-policy" element={<CookiePolicyPage />} />

            {/* Spanish Routes */}
            <Route path="/es" element={<HomePage />} />
            <Route path="/es/clinic" element={<ClinicPage />} />
            <Route path="/es/aston-villa" element={<AstonVillaPage />} />
            <Route path="/es/english-immersion" element={<EnglishImmersionPage />} />
            <Route path="/es/technology" element={<TechnologyPage />} />
            <Route path="/es/about-oakham" element={<AboutOakhamPage />} />
            <Route path="/es/prices" element={<PricesPage />} />
            <Route path="/es/contact" element={<ContactPage />} />
            <Route path="/es/signup" element={<SignUpPage />} />
            <Route path="/es/terms" element={<TermsPage />} />
            <Route path="/es/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/es/cookie-policy" element={<CookiePolicyPage />} />

            {/* French Routes */}
            <Route path="/fr" element={<HomePage />} />
            <Route path="/fr/clinic" element={<ClinicPage />} />
            <Route path="/fr/aston-villa" element={<AstonVillaPage />} />
            <Route path="/fr/english-immersion" element={<EnglishImmersionPage />} />
            <Route path="/fr/technology" element={<TechnologyPage />} />
            <Route path="/fr/about-oakham" element={<AboutOakhamPage />} />
            <Route path="/fr/prices" element={<PricesPage />} />
            <Route path="/fr/contact" element={<ContactPage />} />
            <Route path="/fr/signup" element={<SignUpPage />} />
            <Route path="/fr/terms" element={<TermsPage />} />
            <Route path="/fr/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/fr/cookie-policy" element={<CookiePolicyPage />} />
          </Routes>
        </LanguageProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
